import { render, staticRenderFns } from "./OwnerOnsiteChargableServices.vue?vue&type=template&id=21471ecb&"
import script from "./OwnerOnsiteChargableServices.vue?vue&type=script&lang=js&"
export * from "./OwnerOnsiteChargableServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports